import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'areaCheckedIcon',
    'areaUncheckedIcon',
    'prefectureCheckbox',
    'selectedLabel',
    'unselectedLabel',
    'selectedButtonsContainer',
  ]

  declare areaCheckedIconTargets: HTMLElement[]
  declare areaUncheckedIconTargets: HTMLElement[]
  declare prefectureCheckboxTargets: HTMLInputElement[]
  declare selectedLabelTarget: HTMLElement
  declare unselectedLabelTarget: HTMLElement
  declare selectedButtonsContainerTarget: HTMLElement

  connect() {
    this.updateArea()
  }

  toggleArea({ params: { area } }: { params: { area: string } }) {
    const areaPrefectureCheckboxes = this.prefectureCheckboxTargets.filter(
      (cb) => cb.dataset.prefectureSelectionAreaParam === area
    )
    const allPrefectureSelected = areaPrefectureCheckboxes.every((cb) => cb.checked)
    areaPrefectureCheckboxes.forEach((cb) => (cb.checked = !allPrefectureSelected))
    this.updateArea({ params: { area } })
    // NOTE: checked の変更では change イベントが発火しないため、選択の変更を外部へ通知する
    this.dispatch('changed')
  }

  updateArea({ params: { area } }: { params: { area?: string } } = { params: {} }) {
    const areas = area ? [area] : this.#setAllArea()

    areas.forEach((area) => {
      this.#toggleAreaCheckboxIcons(area)
    })

    this.updateSelectionDisplay()
  }

  updateSelectionDisplay() {
    const selectedPrefectures = this.prefectureCheckboxTargets.filter((cb) => cb.checked)
    const hasSelection = selectedPrefectures.length > 0

    this.unselectedLabelTarget.classList.toggle('d-none', hasSelection)
    this.selectedLabelTarget.classList.toggle('d-none', !hasSelection)

    const selectedCodes = new Set(selectedPrefectures.map((cb) => cb.value))
    const buttons = this.selectedButtonsContainerTarget.querySelectorAll('button[data-prefecture-selection-code-param]')
    buttons.forEach((button) => {
      const code = button.getAttribute('data-prefecture-selection-code-param')
      button.classList.toggle('d-none', !selectedCodes.has(code!))
    })
  }

  selectAllDomestic() {
    this.prefectureCheckboxTargets.forEach((cb) => {
      if (cb.dataset.prefectureSelectionAreaParam !== '海外') {
        cb.checked = true
      }
    })
    this.updateArea()
    this.dispatch('changed')
  }

  clearAll() {
    this.prefectureCheckboxTargets.forEach((cb) => (cb.checked = false))
    this.updateArea()
    this.dispatch('changed')
  }

  deselect({ params: { code } }: { params: { code: string } }) {
    const checkbox = this.prefectureCheckboxTargets.find((cb) => cb.value === String(code))
    if (checkbox) {
      checkbox.checked = false
      this.updateArea({ params: { area: checkbox.dataset.prefectureSelectionAreaParam } })
      this.dispatch('changed')
    }
  }

  #setAllArea() {
    return [
      ...new Set(
        this.prefectureCheckboxTargets.map((cb) => cb.dataset.prefectureSelectionAreaParam!)
      ),
    ]
  }

  #toggleAreaCheckboxIcons(area: string) {
    const areaPrefectureCheckboxes = this.prefectureCheckboxTargets.filter(
      (cb) => cb.dataset.prefectureSelectionAreaParam === area
    )
    const allPrefectureSelected = areaPrefectureCheckboxes.every((cb) => cb.checked)

    const areaCheckedIcon = this.areaCheckedIconTargets.find(
      (icon) => icon.dataset.prefectureSelectionAreaParam === area
    )
    const areaUncheckedIcon = this.areaUncheckedIconTargets.find(
      (icon) => icon.dataset.prefectureSelectionAreaParam === area
    )

    areaCheckedIcon?.classList.toggle('d-none', !allPrefectureSelected)
    areaUncheckedIcon?.classList.toggle('d-none', allPrefectureSelected)
  }
}
